// This returns either the fake or real API based on the
// the value of REACT_APP_USE_MOCK_API when the app is run/built
// Must use commonJS to support dynamic run-time export
if (process.env.REACT_APP_USE_MOCK_API) {
  module.exports = require("./userApiMock");
} else {
  module.exports = require("./userApi");
}
